import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 8000-8999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const rulesErrors = {
  ORIGIN_NOT_FOUND: {
    errorCode: 8000,
    errorMessage: t("The request origin does not resolve to a portal, so the API key cannot be checked."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
